export * from './lib/animal-selection-details.module';
export { AnimalSelectionDetailsComponent } from './lib/animal-selection-details.component';
